














import { TrimDirective, SanitizeDirective } from '@/directive';
import { CreateElement, VNode } from 'vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { FeedModel } from '@/type';

@Component<FeedContentBody>({
  directives: { TrimDirective, SanitizeDirective },
})
export default class FeedContentBody extends Vue {
  // PROPS
  @Prop({ type: Object, required: true })
  feed!: FeedModel.Read.Response.Feed;
}
